'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersService = function () {
  function UsersService(Api) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UsersService);
    this.api = Api;
  }

  (0, _createClass3.default)(UsersService, [{
    key: 'loadUsers',
    value: function loadUsers(data) {
      var url = '/users/list';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'getUser',
    value: function getUser(id) {
      return this.api.call({
        method: 'get',
        url: '/users/get/' + id
      });
    }
  }, {
    key: 'getOrders',
    value: function getOrders(data) {
      var url = '/users/getOrders';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'getComments',
    value: function getComments(id) {
      return this.api.call({
        method: 'get',
        url: '/users/comments/' + id
      });
    }
  }, {
    key: 'saveComments',
    value: function saveComments(data) {
      var url = '/users/saveComment';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'removeComment',
    value: function removeComment(id) {
      var url = '/users/removeComment/' + id;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }]);
  return UsersService;
}();

// WEBPACK FOOTER //


exports.default = UsersService;


/** WEBPACK FOOTER **
 ** ./client/app/modules/users/services/user.service.js
 **/